@if (!isProd) {
  <div class="absolute">
    <p-tag severity="warn" icon="fas fa-vial" [value]="'Environment: ' + env | uppercase"> </p-tag>
  </div>
}
